import { useContext } from 'react';
import {
  BiometryPicturePreviewContext,
  BiometryPicturePreviewContextData,
} from '../contexts/BiometryPicturePreview';

export default function useBiometryPicturePreview(): BiometryPicturePreviewContextData {
  return useContext(BiometryPicturePreviewContext);
}
